export const OTP_TYPES = {
  CONTACT_PHONE: 'CONTACT_PHONE',
  PORTABILITY_PHONE: 'PORTABILITY_PHONE',
};

export const OTP_STATUS = {
  VALID: 'VALID',
  INVALID: 'INVALID',
};
